import { forwardRef, useContext } from 'react';

import { Breakpoint, BreakpointContext } from '@hh.ru/magritte-ui-breakpoint';
import { type GridColumnProps } from '@hh.ru/magritte-ui-grid/types';

import styles from './column.less';

type VisibilityCheckProps = Omit<GridColumnProps, 'children'>;

const isVisible = (sizeProps: VisibilityCheckProps, restriction: boolean, breakpoint: Breakpoint): boolean => {
    if (!restriction) {
        return true;
    }

    return sizeProps[breakpoint] !== 0;
};

export const GridColumn = forwardRef<HTMLDivElement, GridColumnProps>(
    ({ children, xs, s, m, l, xl, xxl, flexibleContent = false, ...props }, ref) => {
        const { renderRestriction, breakpoint } = useContext(BreakpointContext);
        const extendsS = s ?? xs;
        const extendsM = m ?? extendsS;
        const extendsL = l ?? extendsM;
        const extendsXL = xl ?? extendsL;
        const extendsXXL = xxl ?? extendsXL;

        if (
            !isVisible(
                { xs, s: extendsS, m: extendsM, l: extendsL, xl: extendsXL, xxl: extendsXXL },
                renderRestriction,
                breakpoint
            )
        ) {
            return null;
        }

        const classNames = [
            styles[`grid-column`],
            styles[`grid-column_xs-${xs}`],
            styles[`grid-column_s-${extendsS}`],
            styles[`grid-column_m-${extendsM}`],
            styles[`grid-column_l-${extendsL}`],
            styles[`grid-column_xl-${extendsXL}`],
            styles[`grid-column_xxl-${extendsXXL}`],
        ];

        return (
            <div {...props} ref={ref} className={classNames.join(' ')}>
                {flexibleContent ? (
                    children
                ) : (
                    /* Пустой div нужен для сброса flex контейнера*/
                    <div>{children}</div>
                )}
            </div>
        );
    }
);

GridColumn.displayName = 'GridColumn';
